import type { ContextualCatalog, ElementCatalog } from '@app/domains/layers/types/layers.types'
import { atom } from 'jotai'
import { loadable } from 'jotai/utils'
import { layerMetadataAtom, layersFormattedAtom } from './layers.atoms'
import { HazardCatalog } from '@app/domains/hazards/types/hazard.types'
import { LayerMetadataRecord } from '@app/types'

/* -----------------------------
 * Derived atoms elements, hazards and contextual catalogs
 * ---------------------------- */

export const elementCatalogAtom = atom<Promise<ElementCatalog>>(async (get) => {
  const layers = await get(layersFormattedAtom)
  return layers.elements
})
export const hazardCatalogAtom = atom<Promise<HazardCatalog>>(async (get) => {
  const layers = await get(layersFormattedAtom)
  return layers.hazards.hazardDetails
})

export const hazardCatalogLoadableAtom = loadable(hazardCatalogAtom)
export const contextualCatalogAtom = atom<Promise<ContextualCatalog>>(async (get) => {
  const layers = await get(layersFormattedAtom)
  return layers.contextuals
})

export const hazardLayerMetadataAtom = atom<Promise<LayerMetadataRecord[]>>(async (get) => {
  const metadata = await get(layerMetadataAtom)
  return metadata.filter((l) => l.type === 'hazard')
})
